import { useCallback } from 'react';

import { Disease } from 'src/models/Disease.model';
import { Eye } from 'src/models/Eye.model';
import { Result } from 'src/models/Result.model';
import { resolveResult, Session } from 'src/models/Session.model';

export const useHistoryResult = (session: Session) => {
  const getHistoryResult = useCallback(
    (eye: Eye, disease: Disease, historyIndex?: number): Result | undefined => {
      let results;

      if (
        session.history &&
        session.history.length > 0 &&
        historyIndex !== undefined
      ) {
        const resultsJson =
          eye === Eye.LEFT
            ? session.history[historyIndex].LeftEyeResultJson.results
            : session.history[historyIndex].RightEyeResultJson.results;

        const currentResults =
          eye === Eye.LEFT ? session.leftResults : session.rightResults;
        const heatmaps = (currentResults || []).reduce(
          (acc, result) => {
            if (result.heatmapFile) {
              acc[result.disease] = result.heatmapFile;
            }
            return acc;
          },
          {} as Record<Disease, string>,
        );
        results = resolveResult(resultsJson, heatmaps);
      } else {
        results = eye === Eye.LEFT ? session.leftResults : session.rightResults;
      }

      return (results || []).find((result) => result.disease === disease);
    },
    [session],
  );

  return { getHistoryResult };
};
